import "./styles.scoped.css";
import { Helmet } from "react-helmet-async";
interface ContentProps {}

const PageNot: React.FC<ContentProps> = ({}) => {
  return (
    <main className="content">
      <Helmet>
        <title>Błąd - TeamBit</title>
      </Helmet>
      <h1>Błąd 404</h1>
      <p>Nie znaleziono strony o takim adresie</p>
    </main>
  );
};
export default PageNot;
